<template>
<div class="infobox">
 <v-card  fill-height class="box mt-2">
    <v-card-text>
        <v-layout row wrap >
            <v-flex xs12>
                <div class="subheading"><slot></slot></div>
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>
</div>
</template>

<script>
export default {
  name: 'InfoBox'
  
}
</script>

<style scoped>

</style>
